const rankingItems = [
  {
    rank: 1,
    title: '顶流艺人深夜声明事件持续发酵',
    tag: '爆',
    heat: '热度 982万',
    trend: 'up',
    change: '↑ 320%',
  },
  {
    rank: 2,
    title: '千万粉丝网红翻车完整时间线',
    tag: '热',
    heat: '热度 756万',
    trend: 'up',
    change: '↑ 185%',
  },
  {
    rank: 3,
    title: '暑期档票房黑马逆袭深度解析',
    tag: '热',
    heat: '热度 623万',
    trend: 'up',
    change: '↑ 140%',
  },
  {
    rank: 4,
    title: '综艺节目录制争议官方回应',
    tag: '新',
    heat: '热度 498万',
    trend: 'up',
    change: '↑ 95%',
  },
  {
    rank: 5,
    title: '国际娱乐年度十大事件盘点',
    tag: '荐',
    heat: '热度 385万',
    trend: 'stable',
    change: '→ 稳定',
  },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            吃瓜排行
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            实时热度排行，看看现在全网最热的瓜是什么
          </p>
        </div>

        <div className="bg-background-100 rounded-2xl border border-background-200/70 overflow-hidden">
          {rankingItems.map((item, idx) => (
            <a
              key={idx}
              href="#ranking"
              className={`flex items-center gap-4 p-4 md:p-5 hover:bg-primary-50/30 transition-all cursor-pointer ${
                idx < rankingItems.length - 1 ? 'border-b border-background-200/50' : ''
              }`}
            >
              <div
                className={`flex-shrink-0 w-9 h-9 flex items-center justify-center rounded-lg font-bold text-sm ${
                  item.rank === 1
                    ? 'bg-primary-500 text-background-50'
                    : item.rank === 2
                      ? 'bg-primary-400/80 text-background-50'
                      : item.rank === 3
                        ? 'bg-accent-500/80 text-background-50'
                        : 'bg-secondary-300 text-foreground-700'
                }`}
              >
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-semibold text-foreground-800 truncate hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <span className="text-xs text-foreground-500">{item.heat}</span>
              </div>

              <span
                className={`flex-shrink-0 inline-block px-2 py-0.5 rounded-md text-xs font-semibold whitespace-nowrap ${
                  item.tag === '爆'
                    ? 'bg-primary-100 text-primary-600'
                    : item.tag === '热'
                      ? 'bg-accent-100 text-accent-600'
                      : item.tag === '新'
                        ? 'bg-secondary-200 text-secondary-700'
                        : 'bg-secondary-100 text-secondary-600'
                }`}
              >
                {item.tag}
              </span>

              <span
                className={`flex-shrink-0 hidden sm:inline-flex items-center gap-1 text-xs whitespace-nowrap ${
                  item.trend === 'up' ? 'text-primary-500' : 'text-foreground-500'
                }`}
              >
                <i
                  className={`${
                    item.trend === 'up' ? 'ri-arrow-up-line' : 'ri-subtract-line'
                  }`}
                ></i>
                {item.change}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}